/**
 * Renders the AOI polygon as a static (non-interactive) GeoJSON layer.
 * Used when the polygon is locked to prevent accidental moves/edits.
 */
import { useMemo } from 'react';
import { Source, Layer } from 'react-map-gl';
import { useAtomValue } from 'jotai';

import { aoiPolygonAtom } from '../atoms';

export const AoiPolygonLayer = () => {
  const polygon = useAtomValue(aoiPolygonAtom);

  const geojson = useMemo((): GeoJSON.FeatureCollection | null => {
    if (!polygon) return null;
    return {
      type: 'FeatureCollection',
      features: [{ type: 'Feature', geometry: polygon, properties: {} }],
    };
  }, [polygon]);

  if (!geojson) return null;

  return (
    <Source id="aoi-polygon-static" type="geojson" data={geojson}>
      <Layer
        id="aoi-polygon-outline"
        type="line"
        paint={{ 'line-color': '#ff0000', 'line-width': 3 }}
      />
    </Source>
  );
};
